import { Injectable, inject } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { take, tap } from 'rxjs/operators';
import { UserActions, userSelector } from '../store';

@Injectable({
  providedIn: 'root',
})
export class UserTokenResolver implements Resolve<boolean> {
  protected store = inject(Store);
  protected actions = inject(Actions);
  protected router = inject(Router);

  resolve(): Observable<any> {
    this.store.dispatch(UserActions.initUser());

    return new Observable(subscriber => {
      this.store
        .pipe(
          select(userSelector),
          take(1),
          tap(() => {
            subscriber.next(true);
            subscriber.complete();
          })
        )
        .subscribe();
    });
  }
}
